"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var MenuItemPrimarySecondary = function (_a) {
    var primary = _a.primary, secondary = _a.secondary;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.MenuItemPrimary, null, primary),
        react_1.default.createElement(styles_1.MenuItemSecondary, null, secondary)));
};
var MenuItemAll = function (_a) {
    var _b = _a.menuItem, url = _b.url, primary = _b.primary, secondary = _b.secondary, ariaLabel = _a["aria-label"], testid = _a["data-testid"], handleNavigation = _a.handleNavigation;
    return url ? (react_1.default.createElement(styles_1.StyledMenuItemLink, { "aria-label": "".concat(ariaLabel, " link"), key: primary, href: url, target: "_blank", onClick: handleNavigation && handleNavigation(url), "data-testid": "".concat(testid, "-link") },
        react_1.default.createElement(MenuItemPrimarySecondary, { primary: primary, secondary: secondary }))) : (react_1.default.createElement(styles_1.StyledMenuItem, { "aria-label": ariaLabel, key: primary, disableRipple: true, "data-testid": "".concat(testid, "-item") },
        react_1.default.createElement(MenuItemPrimarySecondary, { primary: primary, secondary: secondary })));
};
exports.default = MenuItemAll;
//# sourceMappingURL=MenuItemAll.js.map